// Datas no fuso LOCAL do usuário.
// Regra do projeto: comparações de "dia" SEMPRE via estes helpers —
// nunca `iso.slice(0, 10)` direto (ISO é UTC; no Brasil, 21h+ local vira o dia seguinte em UTC).

/** data local (yyyy-mm-dd) de um Date ou string ISO */
export function toLocalDateIso(d: Date | string): string {
  const date = typeof d === 'string' ? new Date(d) : d;
  return new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
}

export function todayLocalIso(): string {
  return toLocalDateIso(new Date());
}

/** minutos desde 00:00 local para posicionar na timeline */
export function minutesOfDayLocal(iso: string): number {
  const d = new Date(iso);
  return d.getHours() * 60 + d.getMinutes();
}

/** soma dias a uma data local yyyy-mm-dd */
export function addDaysIso(dateIso: string, days: number): string {
  const d = new Date(`${dateIso}T12:00:00`); // meio-dia evita bordas de DST
  d.setDate(d.getDate() + days);
  return toLocalDateIso(d);
}

/** soma meses a uma data local yyyy-mm-dd (ancora no dia 1 p/ evitar overflow de mês) */
export function addMonthsIso(dateIso: string, months: number): string {
  const [y, m] = dateIso.split('-').map(Number);
  const d = new Date(y, m - 1 + months, 1, 12, 0, 0);
  return toLocalDateIso(d);
}

/** yyyy-mm-01 do mês da data */
export function monthStartIso(dateIso: string): string {
  return `${dateIso.slice(0, 7)}-01`;
}

/** rótulo "julho 2026" */
export function monthLabel(dateIso: string): string {
  return new Date(`${dateIso}T12:00:00`).toLocaleDateString('pt-BR', {
    month: 'long',
    year: 'numeric',
  });
}

const DOW_SHORT = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];

export function dowLabel(dateIso: string): string {
  return DOW_SHORT[new Date(`${dateIso}T12:00:00`).getDay()];
}

export function formatDateBR(dateIso: string): string {
  return new Date(`${dateIso}T12:00:00`).toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
  });
}
